export  enum DashboardChartTypesEnum {
  TransactionCount = 0,
  EnergyConsumed = 1,
  Revenue = 2
}
export enum DashboardChartNumbersEnum {
  Time = 0,
  ChargeStations = 1,
  Connectors = 2
}
export enum DashboardDateFilterEnum {
  Today = 0,
  ThisMonth = 1,
  ThisYear = 2
}

